import { render, staticRenderFns } from "./Expansions.vue?vue&type=template&id=2b83c110"
import script from "./Expansions.vue?vue&type=script&lang=js"
export * from "./Expansions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports